/**
 * @owner @Appboy/core-objects
 */
export const customObjectsTypeNameObjectIdUnlinkedUsers =
  "/data_objects/:type_name/:object_id/unlinked_users" as const;
